import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetDatasourceRemoteAgentParams extends IIdItem {
  remoteAgentName: string;
  workflowId?: string;
}

export class SetDatasourceRemoteAgentRequest extends Request<ISetDatasourceRemoteAgentParams, IEmptyResult> {
  constructor(params: ISetDatasourceRemoteAgentParams) {
    super('setDatasourceRemoteAgent', params);
  }
}
